import Reveal from '../components/Reveal';
import themes from '../data/themes';

export default function Themes() {
  return (
    <div className="themes-bg" id="themes">
      <div className="section">
        <Reveal>
          <p className="section-label">Personalize Your Game</p>
          <h2 className="section-title">7 Visual Themes</h2>
          <p className="section-sub">Unlock gorgeous themes and play in the palette that feels like you.</p>
        </Reveal>
        <Reveal delay={80}>
          <div className="themes-grid">
            {themes.map((t) => (
              <div key={t.name} className="theme-swatch">
                <div className="theme-gradient" style={{ background: t.gradient }} />
                <div className="theme-label">{t.name}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  );
}
